import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { strings } from "../../../../common/i18n";

/**
 *  Hook for user table data and operations
 */

export default () => {
    const { auditsCreate } = useSelector((state) => state);

    const columns = [
        {
            accessorKey: "branchName",
            header: strings("branch")
        },
        {
            accessorKey: "locationName",
            header: strings("location")
        },
        {
            accessorKey: "assetsCount",
            header: strings("assetsCount"),
            sortingFn: "alphanumeric"
        }
    ];

    const branchIds = useMemo(() => {
        return auditsCreate.selectedBranches.map((id) => {
            const branchObj = auditsCreate.data.find((el) => el.id === id);
            return branchObj.branch;
        });
    }, [auditsCreate.data]);

    // rows to display for selected branch
    const rows = useMemo(() => {
        return auditsCreate.data.reduce((accum, item) => {
            if (branchIds.includes(item.branch)) {
                accum.push({
                    id: item.id,
                    location: item.location,
                    locationName: item.locationName,
                    branch: item.branch,
                    branchName: item.branchName.join(" "),
                    assetsCount: item.assetsCount
                });
            }
            return accum;
        }, []);
    }, [auditsCreate.data, branchIds]);

    return {
        rows,
        columns
    };
};
